const byTech20 = [
  {
    title: "Cómo verificar desde el explorador",
    value: `
Antes de interactuar con tu contrato o compartirlo, es fundamental **verificar que el despliegue fue exitoso en la blockchain**. Esto garantiza que el contrato realmente está activo en la red seleccionada (por ejemplo, Sepolia) y listo para su uso.

En esta sección aprenderás cómo confirmar que la transacción se completó correctamente usando MetaMask, y cómo validar que tu contrato ya está disponible para ser consultado e interactuado.

---

**1. Revisa la transacción confirmada en MetaMask**

Después de desplegar tu contrato en la red de Sepolia, puedes verificar que la transacción fue confirmada desde la pestaña **Actividad** en MetaMask.  
Aquí se muestra la implementación de contrato con el estado **Confirmado**, indicando que el despliegue fue exitoso y que tu contrato ya está activo en la blockchain de Sepolia.

En la imagen puedes ver cómo aparece la transacción confirmada en MetaMask:

![Transacción confirmada en MetaMask](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-14.png)

**2. Accede a los detalles de la transacción y abre el explorador de bloques**

Haz clic sobre la transacción de "Implementación de contrato" que aparece en la pestaña **Actividad** de MetaMask.  
Se abrirá una ventana emergente con el resumen de la transacción: estado, cuentas involucradas, consumo de gas, tarifas y otros detalles.

En esta ventana, tienes dos opciones clave:
- **Ver en el explorador de bloques:** Haz clic en el enlace azul para abrir el explorador de la red (por ejemplo, SepoliaScan) directamente desde MetaMask.
- **Copiar ID de transacción:** Puedes copiar el identificador de la transacción para buscarla manualmente en el explorador si lo prefieres.

Esto te permite validar públicamente en la blockchain que el contrato fue realmente desplegado y consultar su dirección, confirmaciones, y otros datos técnicos.

En la imagen puedes ver la ventana emergente con el enlace al explorador de bloques:

![Ver en el explorador de bloques desde MetaMask](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-15.png)


**3. Consulta los detalles públicos de tu contrato en el explorador de bloques**

Cuando hagas clic en el enlace **"Ver en el explorador de bloques"** desde MetaMask, se abrirá una nueva pestaña mostrándote el explorador oficial de la red (por ejemplo, SepoliaScan para la red Sepolia).

En esta página podrás ver:
- El **hash de la transacción** y el número de bloque.
- Las direcciones involucradas (“From” y “Interacted With (To)”).
- La **creación del contrato**, incluyendo la dirección final de tu smart contract.
- Los tokens transferidos o creados, la comisión de gas pagada y más detalles técnicos.

Todo esto es público y verificable por cualquier persona, lo que demuestra la transparencia de la blockchain.

En la imagen puedes ver cómo luce la información de tu contrato recién desplegado en el explorador de Sepolia:

![Verifica tu contrato en el explorador de bloques](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-16a.png)

**4. Visualiza la página pública de tu contrato en el explorador**

Después de abrir el enlace desde MetaMask o pegar el hash de tu contrato en el explorador (por ejemplo, SepoliaScan), verás la **página pública** de tu contrato inteligente.

En esta página puedes consultar:
- La **dirección del contrato** ya desplegado.
- El **creador del contrato** (la wallet que lo desplegó).
- El **token tracker** asociado si tu contrato es un token.
- El balance en ETH del contrato, así como todas las transacciones, transferencias de tokens, eventos y más información técnica.

Este panel es la prueba de que tu contrato está activo en la blockchain y accesible para cualquier persona desde cualquier parte del mundo.

En la imagen puedes ver un ejemplo de cómo luce la página de un contrato recién desplegado:

![Página pública del contrato en el explorador de bloques](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-17.png)

**5. Revisa que tu contrato esté recién desplegado y sin actividad adicional**

Cuando abres la página del contrato en el explorador (SepoliaScan, Etherscan, Polygonscan, etc.), verás varias pestañas como **Transactions**, **Token Transfers (ERC-20)**, **Contract** y **Events**.

Justo después de desplegar, es normal que en la pestaña de **Transactions** (Transacciones) aparezca vacía o sin movimientos adicionales, ya que tu contrato acaba de ser creado y todavía no se ha interactuado con él (no hay transferencias, llamadas ni eventos nuevos).

Esto confirma que el contrato está listo para comenzar a usarse y que cualquier actividad nueva será visible en tiempo real desde este panel.

En la imagen puedes ver cómo aparece la pestaña vacía al instante de desplegar el contrato:

![Contrato recién desplegado sin transacciones](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-18.png)

**6. Verifica el código Bytecode de tu contrato en el explorador**

Dentro del explorador de bloques, puedes ir a la pestaña **Contract** para revisar el código **Bytecode** (código de bajo nivel) que fue desplegado en la blockchain.  
Esto es útil para comprobar que realmente hay un contrato funcionando en esa dirección y para posteriores verificaciones, auditorías o publicación del código fuente.

Al desplegar un contrato, primero solo verás este Bytecode, y luego podrás verificar el contrato y subir el código fuente para mayor transparencia.

En la imagen puedes ver el Bytecode generado tras el despliegue:

![Bytecode del contrato desplegado en SepoliaScan](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-19.png)

`


  }
];

export default byTech20;
